export const environment = {
	production: false,
	appVersion: 'v1',
	USERDATA_KEY: 'authf649fc9a5f55',
	isMockEnabled: true,
	apiUrl:  'https://apiwebprivada.aulavirtualusmp.pe/api'
};
